import {WistiaSvc} from '../services/WistiaSvc';
import {Observer} from '../services/ViewPortSvc';
import {StopPlaySvc} from '../services/StopPlaySvc';
import {RescaleSvc} from '../services/RescaleSvc';

export class WistiaPlayer implements ng.IComponentController {
    video: anm.LandingVideo;
    showPreview = true;
    canPlay: boolean;
    inModal: boolean;
    isDuration: boolean;
    canOpenModal: boolean;
    wistiaId    = options.handHeld && this.video.mobileWistiaId ? this.video.mobileWistiaId : this.video.wistiaId;

    onModalClose: () => void      = this.onModalClose || _.noop;
    onReady: (video: any) => void = this.onReady || _.noop;

    private stopPlaySvc: StopPlaySvc;
    private modalShowListener: Function = _.noop;
    private time: number;
    private options: any;
    private defaultOptions              = {
        autoPlay: false
    };
    private play: boolean;
    private isPlayBtn: boolean;
    private wistiaPlayer: any;
    private isVideoPlaying: boolean;

    constructor(private $element: ng.IAugmentedJQuery,
                private $rootScope: ng.IRootScopeService,
                private wistiaSvc: WistiaSvc,
                private ViewPortSvc: Observer) {
        if (options.handHeld) {
            this.isPlayBtn        = false;
            this.inModal          = false;
        }
        this.canPlay = !this.isPlayBtn && (this.video.isMobile || !options.handHeld);

        this.options = {...this.defaultOptions, ...this.options};
        this.setWistiaMedia();

        this.stopPlaySvc = new StopPlaySvc(
            this.$rootScope,
            this.ViewPortSvc,
            this.$element,
            isPlaying => {
                this.isVideoPlaying = isPlaying;
                this.playVideo();
            }
        );

        if (this.canPlay) {
            this.loadVideo();
        }
    }

    $onDestroy() {
        this.wistiaPlayer && this.wistiaPlayer.unbind('heightchange', this.fullscreenChange);
        this.stopPlaySvc.deactivate();
    }

    $onChanges(onChangesObj: ng.IOnChangesObject) {
        const isUpdated   = (obj: ng.IChangesObject<any>) => obj && obj.previousValue !== obj.currentValue;
        this.canOpenModal = this.inModal && this.canPlay;

        if (this.wistiaPlayer && isUpdated(onChangesObj.time)) {
            this.wistiaPlayer.time(this.time);
        }
    }

    loadVideo() {
        this.canPlay = this.video.isMobile || !options.handHeld;
        if (!this.canPlay) return;

        if (this.inModal) {
            this.playInModal();
        } else {
            this.playInside();
        }
    }

    playInModal() {
        let el: HTMLElement;
        this.modalShowListener = this.$rootScope.$on('modal:show', () => {
            el = document.querySelector('.modal-wistia-player');

            el.style.opacity = '0';
        });

        this.canOpenModal = true;

        this.getPlayer().then((videoPlayer: any) => {
            const maxWidth  = (window.innerWidth / 1.4);
            const maxHeight = (window.innerHeight / 1.2);

            const {width, height}  = RescaleSvc.resizeWithAspectRatio(
                videoPlayer.width(),
                videoPlayer.height(),
                maxWidth,
                maxHeight,
                true, true
            );

            const modalPadding = 20;
            videoPlayer.width(width - modalPadding);
            videoPlayer.height(height - modalPadding);

            Object.assign(el.style, {
                width: `${width}px`,
                height: `${height}px`,
                opacity: '1'
            });
        });
    }

    playInside() {
        this.getPlayer().then(() => {
            this.playVideo();
        });
    }

    modalCloseHandler() {
        this.canOpenModal = false;
        this.showPreview  = true;
        this.onModalClose();
        this.modalShowListener();
    }

    private calcTime(time: number) {
        const {floor, ceil} = Math;

        const hrs  = floor(time / 3600);
        const mins = floor((time % 3600) / 60);
        const secs = ceil(time % 60);

        // return "1:01" or "4:03:59" or "123:03:59"
        let ret = "";

        if (hrs > 0) {
            ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
        }

        ret += "" + mins + ":" + (secs < 10 ? "0" : "");
        ret += "" + secs;
        return ret;
    }

    private setWistiaMedia() {
        this.wistiaSvc.getMedia(this.wistiaId).then(media => {
            this.video.preview  = this.video.preview || media.thumbnail.url;
            this.video.duration = this.calcTime(media.duration)
        });
    }

    private getPlayer() {
        return this.wistiaSvc.getWistiaPlayer(this.wistiaId, this.options)
            .then((videoPlayer: any) => {
                this.wistiaPlayer = videoPlayer;
                this.wistiaPlayer.bind('heightchange', this.fullscreenChange);
                this.onReady({video: this.wistiaPlayer});
                return videoPlayer;
            });
    }

    private fullscreenChange = () => {
        const fullscreenElement = document.fullscreenElement || document.mozFullScreenElement ||
            document.webkitFullscreenElement || document.msFullscreenElement;

        if (fullscreenElement != null) {
            this.wistiaPlayer.play();
            this.wistiaPlayer.volume(100);
        } else {
            this.wistiaPlayer.volume(this.options.volume);
        }
    };

    private playVideo() {
        if (this.wistiaPlayer) {
            // fix bug with incorrect height in wistia player
            if (!this.inModal) {
                const width = Math.floor(this.$element[0].getBoundingClientRect().width);
                this.wistiaPlayer.width(width, {constrain: true});
            }

            const canPlay = this.inModal || this.isVideoPlaying;
            if (canPlay) {
                this.wistiaPlayer.play();
                this.showPreview = this.inModal;
            } else {
                this.wistiaPlayer.pause();
            }

            if (this.isVideoPlaying && this.time && this.time > 0) {
                this.wistiaPlayer.time(this.time);
                this.wistiaPlayer.play();
            }
        }
    }
}

angular.module('animatronApp.wistiaPlayer', []).component('wistiaPlayer', {
    bindings: {
        onModalClose: '&?',
        onReady: '&?',
        inModal: '<',
        video: '<',
        time: '<?',
        isPlayBtn: '<?',
        isDuration: '<?',
        options: '<?'
    },
    controller: WistiaPlayer,
    templateUrl: require('wistia-player.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/wistiaPlayer.ts